import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Authroute from '../../../component/authroute';
import { connect } from 'react-redux';
import {redirect} from '../../../redux/reducer/user';

import { signIn } from "../../../api/index";

@withRouter
@connect(
  state=>state.user,
  {redirect}
)
class Admin extends Component{
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: ''
    };
  }
  componentDidMount() {
    let handlerSubmit = this.handlerSubmit;
    $("#login-form").validate({
      rules: {
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          minlength: 6,
          maxlength: 20
        }
      },
      messages: {
        email: {
          required: 'Please enter your email address',
          email: 'Please enter a valid email address'
        },
        password: {
          required: 'Please enter your password'
        }
      },
      submitHandler: function(){
        handlerSubmit();
      },
      errorPlacement: function (error, element) {
        error.insertAfter(element.parent());
      }
    });
  }
  handlerSubmit = ()=>{
    let { email, password } = this.state;
    let { admin } = this.props;
    let roleType = admin==="isos"?"super_admin":"admin";
    let tenantname = this.props.tenantname;
    $("#submitBtn").button('loading');

    signIn({email, password, roleType}, {headers: {'tenantname': tenantname}})
      .then(res=>{
        if (res.status === "success") {
          let data = res.data || {};
          sessionStorage.setItem("token", data.token);
          sessionStorage.setItem("adminName", data.adminName);
          this.props.redirect({redirectTo: ''});
          this.props.history.push('/admin/dashboard');
        }
        $("#submitBtn").button('reset');
      })
      .catch(e=>{
        console.log(e);
        $("#submitBtn").button('reset');
      });
  };
  render() {
    const regularType = this.props.admin.toUpperCase();
    const adminType = this.props.admin==="isos"?"Super":"Tenant";
    let {headlineColor} = this.props;
    return (
      <div id="content" className="container">
        <Authroute />
        <div className="row" style={{marginTop: 14}}>
          <div className="well col-md-6 col-md-offset-3" style={{padding: 20}}>
            <h1 className="login-header-big tex-color-dangreen text-center"
                style={{color: headlineColor}}>
              {`${regularType} Alerts Subscription Management`}
              <br/>
              {`${adminType} Administration Page`}
            </h1>
            <br/>
            <div className="col-md-8 col-md-offset-2">
              <div className="well no-padding">
                <form id="login-form" className="smart-form client-form">
                  <header className="text-center" style={{fontWeight: 400}}>
                    Sign In
                  </header>
                  <fieldset>
                    <section>
                      <label className="label isos-label">E-mail</label>
                      <label className="input">
                        <i className="icon-append fa fa-user" />
                        <input
                          autoFocus={true}
                          type="email"
                          name="email"
                          onChange={v=>this.setState({email: v.target.value})}
                          style={{borderRadius: 5}} />
                        <b className="tooltip tooltip-top-right">
                          <i className="fa fa-user txt-color-teal" />
                          &nbsp;Please enter email address
                        </b>
                      </label>
                    </section>
                    <section>
                      <label className="label isos-label">Password</label>
                      <label className="input">
                        <i className="icon-append fa fa-lock" />
                        <input
                          type="password"
                          name="password"
                          onChange={v=>this.setState({password: v.target.value})}
                          style={{borderRadius: 5}} />
                        <b className="tooltip tooltip-top-right">
                          <i className="fa fa-lock txt-color-teal" />
                          &nbsp;Type your password
                        </b>
                      </label>
                    </section>
                  </fieldset>
                  <footer className="text-center">
                    <input
                      id="submitBtn"
                      type="submit"
                      value="Sign In"
                      className="btn btn-primary btn-lg"
                      style={{
                        float: "none",
                        borderRadius: 5
                      }}/>
                  </footer>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Admin;


// WEBPACK FOOTER //
// ./src/container/login/model/admin.js